import './system.css';
import { Layout, Menu } from '@arco-design/web-react';
import { Header } from '@/components/Header';
import { IconCommand, IconFile, IconNav, IconSettings } from '@arco-design/web-react/icon';
import { useLogin } from '@/pages/Login/useLogin';
import { Outlet, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import _ from "lodash";

const MenuItem = Menu.Item;
const SubMenu = Menu.SubMenu;

export const System = () => {
    useLogin(false);
    const navigate = useNavigate();
    const userInfo = useSelector(state => state.userInfo);

    const onClickMenuItem = (key) => {
        navigate(key);
    }

    useEffect(() => {
        if (userInfo.loaded) {
            const admin = _.indexOf(userInfo.roles, 'admin');
            if (admin < 0) {
                navigate("/workspace");
            }
        }
    }, [userInfo, navigate])

    return (
        <Layout>
            <Layout.Header>
                <Header />
            </Layout.Header>
            <Layout>
                <Layout.Sider className="layout-sider">
                    <Menu onClickMenuItem={onClickMenuItem} style={{ paddingTop: 65, height: "100%", width: 200, position: 'fixed' }}>
                        <MenuItem key='settings'><IconSettings />Settings</MenuItem>
                        <SubMenu key='job' title={<span><IconNav />Job</span>}>
                            <MenuItem key='jobs'><IconCommand />Job Management</MenuItem>
                            <MenuItem key='jobs/logs'><IconFile />Job Logs</MenuItem>
                        </SubMenu>
                    </Menu>
                </Layout.Sider>
                <Layout.Content className="layout-content" style={{ paddingTop: 65 }}>
                    <div className='layout-content-wrapper'>
                        <Outlet />
                    </div>
                </Layout.Content>
            </Layout>
        </Layout >
    );
}